import React, { useEffect, useState } from 'react';
import { Button, Form, Input, Modal, Popconfirm, Space, message } from 'antd';
import ResponsiveTable from '../components/ResponsiveTable';
import { PlusOutlined } from '@ant-design/icons';
import { helpConfigsApi } from '../services/api-services';

const HelpConfigManagement: React.FC = () => {
  const [list, setList] = useState<any[]>([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [editing, setEditing] = useState<any>(null);
  const [form] = Form.useForm();

  const load = async () => { try { const res: any = await helpConfigsApi.list(); setList(res); } catch {} };
  useEffect(() => { load(); }, []);

  const handleSave = async (values: any) => {
    try {
      if (editing) { await helpConfigsApi.update(editing.id, values); message.success('更新成功'); }
      else { await helpConfigsApi.create(values); message.success('创建成功'); }
      setModalVisible(false); form.resetFields(); setEditing(null); load();
    } catch (e: any) { message.error(e.response?.data?.detail || '操作失败'); }
  };

  const handleDelete = async (id: number) => {
    try { await helpConfigsApi.delete(id); message.success('删除成功'); load(); } catch { message.error('删除失败'); }
  };

  const openEdit = (r: any) => {
    setEditing(r);
    form.setFieldsValue({ name: r.name, url_pattern: r.url_pattern, link: r.link });
    setModalVisible(true);
  };

  const openCreate = () => { setEditing(null); form.resetFields(); setModalVisible(true); };

  const columns = [
    { title: '名称', dataIndex: 'name', key: 'name' },
    { title: 'URL匹配规则（正则）', dataIndex: 'url_pattern', key: 'url_pattern', render: (v: string) => <code>{v}</code> },
    { title: '帮助链接', dataIndex: 'link', key: 'link', ellipsis: true },
    { title: '更新时间', dataIndex: 'updated_at', key: 'updated_at', width: 180, render: (v: string) => v ? new Date(v).toLocaleString() : '-' },
    { title: '操作', key: 'action', width: 150, render: (_: any, r: any) => (
      <Space>
        <Button type="link" size="small" onClick={() => openEdit(r)}>编辑</Button>
        <Popconfirm title="确定删除？" onConfirm={() => handleDelete(r.id)} okText="删除" okButtonProps={{ danger: true }} cancelText="取消">
          <Button type="link" danger size="small">删除</Button>
        </Popconfirm>
      </Space>
    )},
  ];

  return (
    <div className="apple-page">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <h1 className="apple-page-title" style={{ marginBottom: 0 }}>帮助配置</h1>
        <Button type="primary" icon={<PlusOutlined />} onClick={openCreate}>新增</Button>
      </div>
      <ResponsiveTable dataSource={list} columns={columns} rowKey="id" pagination={false} />
      <Modal
        title={editing ? '编辑帮助配置' : '新增帮助配置'}
        open={modalVisible}
        onCancel={() => { setModalVisible(false); setEditing(null); form.resetFields(); }}
        onOk={() => form.submit()}
        width={600}
        destroyOnHidden
      >
        <Form form={form} layout="vertical" onFinish={handleSave}>
          <Form.Item name="name" label="名称" rules={[{ required: true, message: '请输入名称' }]}>
            <Input placeholder="如：数字人管理帮助" />
          </Form.Item>
          <Form.Item name="url_pattern" label="URL匹配规则（正则表达式）" rules={[{ required: true, message: '请输入正则表达式' }]} help="匹配当前页面URL的path部分，如 ^/employees">
            <Input placeholder="^/employees" style={{ fontFamily: 'monospace' }} />
          </Form.Item>
          <Form.Item name="link" label="帮助页面链接" rules={[{ required: true, message: '请输入链接' }]}>
            <Input placeholder="https://help.example.com/employees" />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default HelpConfigManagement;
